
import { Injectable } from '@angular/core';
import { BackendService } from '../backend.service';
import { PreAccept, PostAccept, CustomerRiskData, PostAcceptV2, RiskStatus } from './risk';
import { Observable } from 'rxjs';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class RiskService {

  private preAcceptRiskCheckUrl = '/risk_engine/otrocs/preaccept/v2/{customerId}/{loanApplicationId}';
  private customerLastDecisionUrl = '/risk_engine/otrocs/decision/Customers/{customerId}/Decisions/Last';
  private postAcceptRiskUrl = '/risk_engine/otrocs/postaccept/v2/{customerId}/{loanApplicationId}';
  private customerPreAcceptUrl = '/risk_engine/otrocs/preapprove/v2/{customerId}';
  private customerPostAcceptUrl = '/risk_engine/otrocs/preapprove/v2/{customerId}';
  private checkCustomerCreditLimitUrl = '/risk_engine/otrocs/preapprove/v2/{customerId}/0.0';
  private getCreditLimitUrl = '/risk_engine/otrocs/preapprove/v2/{customerId}/{loanApplicationId}';
  private riskTaskUrl = '/risk_engine/otrocs/checkout/v2/{customerId}/{loanApplicationId}';
  private riskErrorCodesUrl = '/error_codes.json';
  private customerRiskData = '/dag-manager/api/v1/customer/{customerId}/v1/risk-data';
  private checkCustomerCreditLimitUrlV2 = '/dag-manager/api/v1/customers/{customerId}/credit-limit';
  private getRiskStatusUrl = '/dag-manager/api/v1/otrocs/decision/customers/{customerId}?stages=CLAllocationStage1,CLAllocationStage2,CLAllocationStage3';
  private getComplianceConsentUrl = '/customer-details/api/v1/consent/customers/{customerId}';
  private consentNullUrl = '?softpullCibilConsent=null&hardpullCibilConsent=null';
  constructor(private backendService: BackendService) { }

  preAcceptRiskCheck(loanApplicationId: string, consentStatus?: any): Observable<PreAccept> {
    const consentUrl = consentStatus ? this.replaceRiskCheckUrl(consentStatus) : this.consentNullUrl;
    if (loanApplicationId) {
      this.preAcceptRiskCheckUrl += consentUrl;
      return this.backendService.getData(this.preAcceptRiskCheckUrl.replace('{loanApplicationId}', loanApplicationId));
    } else {
      return this.backendService.getData(this.customerPreAcceptUrl + consentUrl);
    }
  }
  postAcceptRiskCheck(loanApplicationId: string): Observable<PostAccept> {
    if (loanApplicationId) {
      return this.backendService.getData(this.postAcceptRiskUrl.replace('{loanApplicationId}', loanApplicationId));
    } else {
      return this.backendService.getData(this.customerPostAcceptUrl);
    }
  }
  replaceRiskCheckUrl(consentStatus: any) {
    const consentUrl = `?softpullCibilConsent=${consentStatus.isCibilSoftPullConsentSubmitted}&hardpullCibilConsent=${consentStatus.isCibilHardPullConsentSubmitted}`;
    return consentUrl;
  }
  checkCustomerCreditLimitV2(): Observable<PostAcceptV2> {
    return this.backendService.getData(this.checkCustomerCreditLimitUrlV2);
  }
  checkCustomerCreditLimit(): Observable<PostAccept> {
    return this.backendService.getData(this.checkCustomerCreditLimitUrl);
  }
  getCreditLimit(loanApplicationId: string): Observable<PostAccept> {
    return this.backendService.getData(this.getCreditLimitUrl.replace('{loanApplicationId}', loanApplicationId));
  }
  getLastDecision(): Observable<any> {
    return this.backendService.getData(this.customerLastDecisionUrl);
  }
  getStatus(): Observable<PostAccept> {
    return this.backendService.getData(this.customerPreAcceptUrl);
  }
  createRiskTask(loanApplicationId: string) {
    return this.backendService.getData(this.riskTaskUrl.replace('{loanApplicationId}', loanApplicationId));
  }
  getRiskErrorCodes() {
    return this.backendService.getData(this.riskErrorCodesUrl, null, false, true, true);
  }
  getRiskStatus(): Observable<RiskStatus> {
    return this.backendService.getData(this.getRiskStatusUrl);
  }
  getCustomerRiskData(fromDate: string): Observable<CustomerRiskData> {
    const postData = {
      'fetch_customer_risk_decisions': true,
      'customer_risk_decision_query_params': {
        'from_time': fromDate,
        'risk_journey_types': [
          'CreditLimitIncrease'
        ]
      },
      'fetch_customer_credit_limit_histories': true,
      'customer_credit_limit_history_query_params': {
        'from_time': fromDate,
        'history_types': [
          21
        ]
      }
    };
    return this.backendService.setData(this.customerRiskData, postData);
  }
  getConsentStatus(): Observable<any> {
    return this.backendService.getData(this.getComplianceConsentUrl);
  }
}

@Injectable()
export class LastDecisionResolveService implements Resolve<any> {
  constructor(private riskService: RiskService) { }
  resolve(route: ActivatedRouteSnapshot): Promise<any> {
    return new Promise((resolve, reject) => {
      this.riskService.getLastDecision().subscribe(applicationResponse => {
        resolve(applicationResponse);
      }, error => {
        resolve(null);
      });
    });
  }
}
